import { useQuery } from '@apollo/client'
import React, { useEffect, useState } from 'react'
import { GET_ROLE_BY_ID } from '../../../../../graphql/Catalog/Roles/roles'
import InputController from '../../../../Global/InputController'
import { useForm } from 'react-hook-form'
import { objNameRoles } from '../../../../../const/constRoles'
import { GET_USER_DATA_BY_ID } from '../../../../../graphql/Catalog/Users/user'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import UserRatingInfo from './UserRatingInfo'

export const Sidebar = ({ info, user }) => {
  //--------------------QUERIES--------------------
  const { data, loading, error } = useQuery(GET_ROLE_BY_ID, {
    variables: { getOneRoleId: parseInt(user.role) },
  })

  const {
    data: dataUser,
    loading: loadingUser,
    error: errorUser,
  } = useQuery(GET_USER_DATA_BY_ID, {
    variables: {
      getUserDataByIdId: parseInt(user.idUser),
    },
  })

  //--------------------STATES--------------------
  const [previewPic, setPreviewPic] = useState(null)
  const [roleName, setRoleName] = useState('')
  const [description, setDescription] = useState('')
  const { control } = useForm()

  //--------------------USE EFFECTS--------------------
  useEffect(() => {
    if (info) {
      setPreviewPic(info?.GetUserById?.avatarUrl)
    }
  }, [info])

  useEffect(() => {
    if (!loading && !loadingUser) {
      if (error || errorUser)
        return toastSweetAlert({
          type: 'error',
          text: error?.message || errorUser?.message,
        })

      if (data) {
        const { description, role_name } = data.getOneRole
        setRoleName(role_name)
      }
      if (dataUser?.GetUserDataById) {
        const { JobPositionOfUser } = dataUser.GetUserDataById
        setDescription(JobPositionOfUser?.name)
      }
    }
  }, [data, loading, error, dataUser, loadingUser, errorUser])

  return (
    <div className="col-lg-3 col-md-6 col-sm-12">
      <div className="card card-primary">
        <div className="card-body box-profile">
          <div className="text-center container-upload">
            <form>
              <InputController
                label="Avatar"
                inputType="imageAutoSend"
                userId={user.idUser}
                name="avatar"
                previewPic={previewPic}
                validateFormat="imageAvatar"
                validateFormatMsg="Solo se admite JPG, JPEG y PNG"
                formatAccept="image/png, image/jpg, image/jpeg"
                control={control}
              />
            </form>
          </div>

          <h3 className="profile-username text-center">{user.name}</h3>
          <UserRatingInfo userId={user.idUser} />

          <p className="text-muted text-center">
            <b>{roleName}</b>
            <br />
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
